mutation UserTemplateUpdate($input: UserTemplateUpdateInput!) {
  userTemplateUpdate(input: $input) {
    departmentOccupationTemplate {
      id
      description
      name
      _rowTimestamp
    }
  }
}